import fallbackFactory from '../../utils/fallback-factory';
import { TModalBase } from '../../models/modal.model';

export const modalFactory = (componentName: string) => {
    return fallbackFactory<TModalBase>(
        () => import(`../../components/modals/${componentName}`),
        () => import(`../../components/modals/empty`)
    );
};
